export const EndPoint = {
  MASTER: "/master/emt-proxy",
  FLIGHT_LIST: "flightSearch",
  CALENDER_FARE: "calendarFare",
  AIR_RE_PRICE_RQ: "airReprice",
  ADD_ON_SERVICES: "getAddonServices",
  FLIGHT_BOOKING: "airBook",
  GET_BOOKING: "getBooking",
};
